import { useStudentStore } from "../../hooks/use-student-store";

const CompletionResults = () => {
  const { submission } = useStudentStore();

  if (!submission || submission.status !== "COMPLETED") return null;

  const feedback = submission.feedback as {
    strengths?: string[];
    areas_for_improvement?: string[];
    summary?: string;
  } | undefined;

  return (
    <div className="space-y-4">
      {feedback?.summary && (
        <p className="text-gray-700 mt-4">{feedback.summary}</p>
      )}

      {submission.questions_for_class && submission.questions_for_class.length > 0 && (
        <div>
          <p className="text-lg font-semibold text-gray-900 mb-2">Questions to Ponder for Class</p>
            <ul className="space-y-2">
              {submission.questions_for_class.map((question, index) => (
                <li key={index} className="flex items-start gap-2">
                  <span className="text-gray-500">•</span>
                  <span className="text-gray-700">{question}</span>
                </li>
              ))}
            </ul>
        </div>
      )}
    </div>
  );
};

export default CompletionResults;
